module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/haircut-desktop@2x-3f7f4c04774f63559ccc783bd525eee1.jpg";